export default __webpack_public_path__ + "static/media/fl2-rev.4ada6889.png";